import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { Box } from "@mui/material";
import downloadjs from "downloadjs";
import GoogleMapReact from "google-map-react";
import * as React from "react";
import { MapMarker } from "ui/Scripts/source/components/framework/mapMarker";
import { Base } from "ui/Scripts/source/framework/base";
import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { EditItem } from "ui/Scripts/source/models/common/editItem";
import { FileAttachment, IFileAttachment } from "ui/Scripts/source/models/common/fileAttachment";
import { IdColorTitle } from "ui/Scripts/source/models/common/idColorTitle";
import { IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { LockedRecord } from "ui/Scripts/source/models/common/lockedRecord";
import { SaveAttachmentBase64 } from "ui/Scripts/source/models/common/saveAttachmentBase64";
import { SaveSuccess } from "ui/Scripts/source/models/common/saveSuccess";
import { ICompanyMenuItem } from "ui/Scripts/source/models/company/companyMenuItem";
import { removeConfirmationWord } from "ui/Scripts/source/models/consts";
import { ConfirmationDialogResult, DatabaseRecordType } from "ui/Scripts/source/models/enums";
import { IEventSettingSimple } from "ui/Scripts/source/models/eventSettings/eventSettingSimple";
import { Translations } from "ui/Scripts/source/models/translations";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";
import { AppUtils } from "../../../framework/appUtils";
import { SaveDataObj } from "../../../framework/saveData";
import { EventEditItem, IEventEditItem } from "../../../models/event/eventEditItem";
import { EventEditItemMessage, IEventEditItemMessage } from "ui/Scripts/source/models/event/eventEditItemMessage";
import { EventTypeNode } from "../../../models/eventType/eventTypeNode";
import * as attachmentService from "../../../models/services/attachmentService";
import * as eventService from "../../../models/services/eventService";
import { recordLockManager } from "../../../models/services/recordLockService";
import { ISessionState } from "../../../models/session/sessionState";
import { StoreUtils } from "../../../models/store/storeUtils";
import { ConfirmationButton } from "../../framework/Button/ConfirmationButton";
import { DangerButton } from "../../framework/Button/DangerButton";
import { Dialog } from "../../framework/Dialog/Dialog";
import { DialogItemsNav } from "../../framework/Dialog/DialogItemsNav";
import { DialogTabs } from "../../framework/Dialog/DialogTabs";
import { SelectUnitDialog } from "../../framework/Unit/SelectUnitDialog";
import { EventEditDialogAction } from "./EventEditDialogAction";
import { EventEditDialogBasicInformation } from "./EventEditDialogBasicInformation";
import { EventEditDialogIdentification } from "./EventEditDialogIdentification";
import { AppButton } from "ui/Scripts/source/components/framework/Button/AppButton";

/* eslint-disable no-unused-vars */
export const enum EventEditDialogMenuItem {
    Event = "1",
    Handling = "2",
    Identification = "3",
    Location = "4"
}
/* eslint-enable no-unused-vars */

 interface IEventEditDialogProp {
    sessionState: ISessionState;
    companyId: string;
    eventId: string;
    classes?: string;
    hasPrevious: boolean;
    hasNext: boolean;
    onOk: () => void;
    onClose: () => void;
    onRemoved: () => void;
    onRefreshList: () => Promise<void>;
    onPrevious: () => void;
    onNext: () => void;
}

interface IEventEditDialogState {
    screenHeight: number;
    activeMenuItem: EventEditDialogMenuItem;
    isLoading: boolean;
    event: IEventEditItem;
    createCompany: ICompanyMenuItem;
    companies: ICompanyMenuItem[];
    units: IIdTitleNode[];
    eventSetting: IEventSettingSimple;
    maxEventMessageAttachmentSize: number;
    urgencyClasses: IdColorTitle[];
    eventTypeNodes: IIdTitleNode[];
    eventTypeBNodes: IIdTitleNode[];
    eventTypeCNodes: IIdTitleNode[];
    canHandleEvent: boolean;
    canRemoveEvent: boolean;
    canSaveEvent: boolean;
    canEditIdentificationData: boolean;
    isLockedToOtherUser: boolean;
    userIsCreator: boolean;
    processingTimeStr: string;
    // General
    id: string;
    rowId: string;
    dateStr: string;
    timeStr: string;
    unitId: string;
    unitCode: string;
    urgencyClassId: string;
    createCompanyUnitId: string;
    createCompanyUnitCode: string;
    name: string;
    observer: string;
    observerAction: string;
    description: string;
    firstApproveUser: IModifyUser;
    lastApproveUser: IModifyUser;
    lockedUser: IModifyUser;
    handlers: IModifyUser[];
    attachments: IFileAttachment[];
    //Actions
    immediateAction: string;
    preventiveAction: string;
    rootCause: string;
    messages: IEventEditItemMessage[];
    //Identification
    eventTypeIds: string[];
    eventTypeBIds: string[];
    eventTypeCIds: string[];
    identificationDetails: string;
    directCostsStr: string;
    indirectCostsStr: string;
    amountStr: string;
    //Dialogs
    showSelectUnitDialog: boolean;
}

export class EventEditDialog extends React.Component<IEventEditDialogProp, IEventEditDialogState> {
    private defaultPrintId = "00000000-0000-0000-0000-000000000000";
    private orgStateHash: string = "";

    getScreenHeight = () => {
        return window.innerHeight >= 800
            ? 0
            : (window.innerHeight >= 650
                ? 1
                : 2);
    };

    constructor(props: IEventEditDialogProp) {
        super(props);
        this.state = {
            screenHeight: this.getScreenHeight(),
            activeMenuItem: EventEditDialogMenuItem.Event,
            isLoading: false,
            event: null,
            createCompany: null,
            companies: [],
            units: [],
            eventSetting: null,
            maxEventMessageAttachmentSize: 0,
            urgencyClasses: [],
            eventTypeNodes: [],
            eventTypeBNodes: [],
            eventTypeCNodes: [],
            canHandleEvent: false,
            canRemoveEvent: false,
            canSaveEvent: false,
            canEditIdentificationData: false,
            isLockedToOtherUser: false,
            userIsCreator: false,
            processingTimeStr: "",
            // General
            id: "",
            rowId: "",
            dateStr: "",
            timeStr: "",
            unitId: "",
            unitCode: "",
            urgencyClassId: "",
            createCompanyUnitId: "",
            createCompanyUnitCode: "",
            name: "",
            observer: "",
            observerAction: "",
            description: "",
            firstApproveUser: null,
            lastApproveUser: null,
            lockedUser: null,
            handlers: [],
            attachments: [],
            //Actions
            immediateAction: "",
            preventiveAction: "",
            rootCause: "",
            messages: [],
            //Identification
            eventTypeIds: [],
            eventTypeBIds: [],
            eventTypeCIds: [],
            identificationDetails: "",
            directCostsStr: "",
            indirectCostsStr: "",
            amountStr: "",
            //Dialogs
            showSelectUnitDialog: false,
        };
    }

    loadEvent = async (eventId: string): Promise<void> => {
        const props = this.props;
        //Unlock current event
        if (LockedRecord.isLockedToUser(this.state.lockedUser, props.sessionState.code)) {
            await recordLockManager.unlock(props.companyId, this.state.event?.id, DatabaseRecordType.Event);
        }
        //Load and lock event
        this.setState({ isLoading: true });
        const result = await AppUtils.callService(() => eventService.getEventEdit(props.companyId, eventId, true), false, false, () => this.setState({ isLoading: false }));
        if (!result) return;
        const event = result.item;
        const firstAndLastApproved = EventEditItem.getFirstAndLastApproveHandler(event.handlers);
        const userIsCreator = event.createUser.code === props.sessionState.code;
        const state = {
            ...this.state,
            activeMenuItem: (this.state.activeMenuItem === EventEditDialogMenuItem.Identification && !result.canEditIdentificationData) || (this.state.activeMenuItem === EventEditDialogMenuItem.Location && !event.locationName)
                ? EventEditDialogMenuItem.Event
                : this.state.activeMenuItem,
            event,
            createCompany: result.createCompany,
            companies: result.companies,
            units: result.units,
            eventSetting: result.eventSetting,
            maxEventMessageAttachmentSize: result.maxEventMessageAttachmentSize,
            urgencyClasses: result.urgencyClasses,
            eventTypeNodes: EventTypeNode.getAsIdTitleNodes(result.eventTypeNodes),
            eventTypeBNodes: EventTypeNode.getAsIdTitleNodes(result.eventTypeBNodes),
            eventTypeCNodes: EventTypeNode.getAsIdTitleNodes(result.eventTypeCNodes),
            canHandleEvent: result.canHandleEvent,
            canRemoveEvent: result.canRemoveEvent,
            canSaveEvent: result.canSaveEvent,
            canEditIdentificationData: result.canEditIdentificationData,
            isLockedToOtherUser: event.isLockedToOtherUser(props.sessionState.code),
            userIsCreator,
            processingTimeStr: EventEditItem.getProcessingTimeStr(firstAndLastApproved.lastApprove, event.publishUser, event.createUser),
            // General
            id: event.id,
            rowId: event.rowId,
            companyId: props.companyId,
            dateStr: Base.timeToDateStr(event.date),
            timeStr: Base.timeToTimeStr(event.date),
            unitId: event.unitId,
            unitCode: event.unitCode,
            urgencyClassId: event.urgencyClassId,
            createCompanyUnitId: event.createCompanyUnitId,
            createCompanyUnitCode: event.createCompanyUnitCode,
            name: event.name,
            observer: event.observer,
            observerAction: event.observerAction,
            description: event.description,
            lockedUser: event.lockedUser,
            handlers: ModifyUser.sortModifyUsers(event.handlers, { currentUserCode: props.sessionState.code }),
            attachments: event.attachments,
            firstApproveUser: firstAndLastApproved.firstApprove,
            lastApproveUser: firstAndLastApproved.lastApprove,
            //Actions
            eventTypeIds: event.eventTypeIds,
            eventTypeBIds: event.eventTypeBIds,
            eventTypeCIds: event.eventTypeCIds,
            immediateAction: event.immediateAction,
            preventiveAction: event.preventiveAction,
            rootCause: event.rootCause,
            messages: event.messages,
            //Identification
            identificationDetails: event.identificationDetails,
            directCostsStr: event.directCosts.toLocaleFixed(2),
            indirectCostsStr: event.indirectCosts.toLocaleFixed(2),
            amountStr: event.amount.toLocaleFixed(2),
        };
        this.setState(state);
        const saveData = this.getSaveDataFromState(props, state);
        this.orgStateHash = saveData.hash;
        //Add locked record to idb
        if (LockedRecord.isLockedToUser(event.lockedUser, props.sessionState.code)) {
            recordLockManager.addLock(LockedRecord.createLockedRecord(props.companyId, state.id, props.sessionState.code, DatabaseRecordType.Event));
        }
        //Send read receipt for event
        if (!userIsCreator && !event.isRead && event.isPublished()) {
            AppUtils.callService(() => eventService.sendEventReadReceipt(props.companyId, state.id), false, true);
        }
    };

    updateHeight = () => {
        const screenHeight = this.getScreenHeight();
        if (screenHeight === this.state.screenHeight) return;
        this.setState({ screenHeight });
    };

    componentDidMount(): void {
        window.addEventListener("resize", this.updateHeight);
        this.loadEvent(this.props.eventId);
    }

    async componentWillUnmount(): Promise<void> {
        const props = this.props;
        window.removeEventListener("resize", this.updateHeight);
        if (LockedRecord.isLockedToUser(this.state.lockedUser, props.sessionState.code)) {
            await recordLockManager.unlock(props.companyId, props.eventId, DatabaseRecordType.Event);
        }
    }

    async componentDidUpdate(prevProps: IEventEditDialogProp, prevState: IEventEditDialogState): Promise<void> {
        const props = this.props;
        const state = this.state;
        if (prevProps.companyId === props.companyId && prevProps.eventId === props.eventId) return;
        const cancelResult = await AppUtils.cancel(this.getSaveDataFromState(props, state).hash, this.orgStateHash, null);
        if (cancelResult === ConfirmationDialogResult.Cancel) return;
        if (cancelResult === ConfirmationDialogResult.Yes) {
            if (!await this.saveToDb(false)) return;
            if (!props.onRefreshList) {
                await props.onRefreshList();
            }
        }
        await this.loadEvent(props.eventId);
    }

    handleToggleActiveMenuItem = (userDialogMenuItem: EventEditDialogMenuItem) => {
        this.setState({ activeMenuItem: userDialogMenuItem });
    };

    handleChange = (name: string, value: string) => {
        if (!name) return;
        if (name === "date") {
            this.setState({ dateStr: value });
        } else if (name === "time") {
            this.setState({ timeStr: value });
        } else if (name === "unitId") {
            this.setState({ unitId: value });
        } else if (name === "urgencyClassId") {
            this.setState({ urgencyClassId: value });
        } else if (name === "name") {
            this.setState({ name: value });
        } else if (name === "observer") {
            this.setState({ observer: value });
        } else if (name === "observerAction") {
            this.setState({ observerAction: value });
        } else if (name === "description") {
            this.setState({ description: value });
        //Actions
        } else if (name === "immediateAction") {
            this.setState({ immediateAction: value });
        } else if (name === "preventiveAction") {
            this.setState({ preventiveAction: value });
        } else if (name === "rootCause") {
            this.setState({ rootCause: value });
        //Identification
        } else if (name === "identificationDetails") {
            this.setState({ identificationDetails: value });
        } else if (name === "directCosts") {
            this.setState({ directCostsStr: value });
        } else if (name === "indirectCosts") {
            this.setState({ indirectCostsStr: value });
        } else if (name === "amount") {
            this.setState({ amountStr: value });
        }
    };

    handleBlur = (name: string, value: string) => {
        if (!name) return;
        //Identification
        if (name === "directCosts") {
            this.setState({ directCostsStr: value.toDecimal().toLocaleFixed(2) });
        } else if (name === "indirectCosts") {
            this.setState({ indirectCostsStr: value.toDecimal().toLocaleFixed(2) });
        } else if (name === "amount") {
            this.setState({ amountStr: value.toDecimal().toLocaleFixed(2) });
        }
    };

    handleChangeEventTypeIds = (ids: string[]) => {
        this.setState({ eventTypeIds: ids });
    };

    handleChangeEventTypeBIds = (ids: string[]) => {
        this.setState({ eventTypeBIds: ids });
    };

    handleChangeEventTypeCIds = (ids: string[]) => {
        this.setState({ eventTypeCIds: ids });
    };

    // #region Locking
    handleUnlockAndLockToMe = async () => {
        const props = this.props;
        if (await AppUtils.showConfirmationDialog(String.format(Translations.DoYouReallyWantToUnlockEvent, this.state.event.name), false) !== ConfirmationDialogResult.Yes) {
            return;
        }
        const result = await recordLockManager.lock(props.companyId, props.eventId, props.sessionState.code, DatabaseRecordType.Event);
        if (!result || result.items.length < 1) return;
        this.setState({
            lockedUser: StoreUtils.getNowModifyUser(result.items[0].lockedDate),
            isLockedToOtherUser: false
        });
    };
    // #endregion Locking

    // #region Attachments
    handleAttachmentDownload = async (id: string) => {
        if (!id) return;
        const state = this.state;
        const attachment = state.attachments.find(i => i.id === id);
        if (!attachment) return;
        if (attachment.file) {
            downloadjs(attachment.file, attachment.name);
            return;
        }
        if (attachment.isNew()) return;
        const fileName = await AppUtils.callService(() => attachmentService.getAttachment(id));
        if (!fileName) return;
        AppUtils.showSuccessMessage(String.format(Translations.AttachmentParameterDownloaded, fileName));
    };

    getRemoveAttachmentsSaveData = (state: IEventEditDialogState, category: number, attachmentIds: string[]): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("id", state.id);
        result.append("companyId", state.event.companyId);
        result.append("category", category);
        result.append("ids", attachmentIds);
        return result;
    };

    handleAttachmentRemove = async (category: number, id: string) => {
        if (!id) return;
        const state = this.state;
        if (await AppUtils.showConfirmationDialog(String.format(Translations.DoYouReallyWantToRemoveAttachmentParameter, state.attachments.find(x => x.id === id)?.name), false) === ConfirmationDialogResult.No) return;
        const saveData = this.getRemoveAttachmentsSaveData(state, category, [id]);
        const result = AppUtils.callService(() => eventService.eventEditRemoveAttachments(saveData.obj));
        if (!result) return;
        this.setState({
            attachments: state.attachments.filter(i => i.id !== id)
        });
    };

    getAddAttachmentsSaveData = async (state: IEventEditDialogState, category: number, attachments: IFileAttachment[]): Promise<SaveDataObj> => {
        const result = new SaveDataObj();
        result.append("id", state.id);
        result.append("companyId", state.event.companyId);
        result.append("subOwnerId", null);
        result.append("category", category);
        result.append("attachments", await SaveAttachmentBase64.fromFileAttachments(attachments.filter(i => !!i.file)));
        return result;
    };
    
    handleAttachmentsAdd = async (category: number, fileList: FileList) => {
        const state = this.state;
        const attachments = await FileAttachment.addFileListToFileAttachments([], fileList, category);
        if (attachments.length < 1) return;
        const saveData = await this.getAddAttachmentsSaveData(state, category, attachments);
        const result = await AppUtils.callService(() => eventService.eventEditAddAttachments(saveData.obj));
        if (!result) return;
        EditItem.setItemIdsFromIds(attachments, result.ids);
        this.setState({
            attachments: state.attachments.concat(attachments)
        });
    };
    // #endregion Attachments

    // #region Select Unit
    handleSelectUnit = () => {
        this.setState({
            showSelectUnitDialog: true
        });
    };

    handleSelectUnitDialogOk = async (node: IIdTitleNode) => {
        const props = this.props;
        const state = this.state;
        if (!node) return;
        const event = state.event;
        const activeCompanyIsReceivingCompany = props.companyId === event.companyId;
        const activeCompanyIsSendingCompany = props.companyId === event.createCompanyId;
        if (activeCompanyIsReceivingCompany) {
            const result = await AppUtils.callService(() => eventService.getDefaultEventHandlersForUnit(event.companyId, event.companyId, node.id, event.isNew()));
            if (!result) return null;
            const oldHandlerCodes = state.handlers.map(i => i.code);
            this.setState({
                showSelectUnitDialog: false,
                unitId: result.unitId,
                unitCode: result.unitCode,
                createCompanyUnitId: activeCompanyIsSendingCompany
                    ? result.unitId
                    : state.createCompanyUnitId,
                createCompanyUnitCode: activeCompanyIsSendingCompany
                    ? result.unitCode
                    : state.createCompanyUnitCode,
                canHandleEvent: result.canHandleEvent,
                canEditIdentificationData: result.canEditIdentificationData,
            });
            //Set new event handlers if not closed
            const isClosed = !!state.lastApproveUser;
            if (!isClosed) {
                const isPublished = !!event.publishUser;
                const handlerResult = !isPublished
                    ? this.updateHandlers(result.handlers, true, false)
                    : this.addHandlers(result.handlers.filter(i => oldHandlerCodes.indexOf(i.code) < 0), false);
                if (!handlerResult) return;
                this.handleSave(false, isPublished);
            }
        } else {
            this.setState({
                showSelectUnitDialog: false,
                createCompanyUnitId: node.id,
                createCompanyUnitCode: node.title
            });
        }
    };

    handleSelectUnitDialogCancel = () => {
        this.setState({
            showSelectUnitDialog: false
        });
    };
    // #endregion Select Unit

    // #region Handlers
    updateHandlers = async (newHandlers: IModifyUser[], canRemove: boolean, showSuccessMessage: boolean): Promise<ApiSuccess> => {
        const props = this.props;
        const state = this.state;
        const oldHandlerCodes = state.handlers.map(i => i.code);
        const addHandlers = (newHandlers ?? []).filter(i => oldHandlerCodes.indexOf(i.code) < 0);
        const removeHandlerCodes = canRemove
            ? oldHandlerCodes.filter(i => (newHandlers ?? []).findIndex(j => j.code === i) < 0)
            : [];
        if (addHandlers.length < 1 && removeHandlerCodes.length < 1) return;
        let handlers: IModifyUser[] = state.handlers.slice(0);
        if (removeHandlerCodes.length > 0) {
            const removeResult = await AppUtils.callService(() => eventService.eventEditRemoveHandlers(props.companyId, state.id, removeHandlerCodes), showSuccessMessage);
            if (!removeResult) return null;
            handlers = handlers.filter(i => removeHandlerCodes.indexOf(i.code) < 0);
        }
        if (addHandlers.length > 0) {
            const addResult = await AppUtils.callService(() => eventService.eventEditAddHandlers(props.companyId, state.id, addHandlers.map(i => i.code)), showSuccessMessage);
            if (!addResult) return null;
            for (const user of addHandlers) {
                user.date = 0;
            }
            handlers = handlers.concat(addHandlers);
        }
        handlers = ModifyUser.sortModifyUsers(handlers, { currentUserCode: props.sessionState.code });
        const firstAndLastApproved = EventEditItem.getFirstAndLastApproveHandler(handlers);
        this.setState({
            handlers,
            processingTimeStr: EventEditItem.getProcessingTimeStr(firstAndLastApproved.lastApprove, state.event.publishUser, state.event.createUser)
        });
        return new ApiSuccess();
    };

    addHandlers = async (users: IModifyUser[], showSuccessMessage: boolean): Promise<ApiSuccess> => {
        if (!users || users.length < 1) return null;
        return this.updateHandlers(users, false, showSuccessMessage);
    };

    handleAddHandlers = async (users: IModifyUser[]): Promise<ApiSuccess> => {
        return this.addHandlers(users, true);
    };

    handleRemoveHandlers = async (userCodes: string[]): Promise<ApiSuccess> => {
        const state = this.state;
        if (!userCodes || userCodes.length < 1) return null;
        return this.updateHandlers(state.handlers.filter(i => userCodes.indexOf(i.code) < 0), true, true);
    };

    handleApprove = async (userCode: string) => {
        const props = this.props;
        const state = this.state;
        if (!userCode) return;
        const handler = state.handlers.find(i => i.code === userCode);
        if (!handler) return;
        if (!state.immediateAction) {
            if (await AppUtils.showConfirmationDialog(Translations.ApproveEventHandlerConfirmation, false) !== ConfirmationDialogResult.Yes) {
                return;
            }
        }
        // Save event
        const saveResult = await this.handleSave(false, false);
        if (!saveResult) return;
        // Call server
        const result = await AppUtils.callService(() => eventService.approveEvent(props.companyId, state.event.createCompanyId, state.id));
        if (!result) return;
        handler.date = Base.getNowTicks();
        const handlers = ModifyUser.sortModifyUsers(state.handlers.filter(i => i.code !== userCode).concat([new ModifyUser(handler)]), { currentUserCode: props.sessionState.code });
        const firstAndLastApproved = EventEditItem.getFirstAndLastApproveHandler(handlers);
        this.setState({
            handlers,
            firstApproveUser: firstAndLastApproved.firstApprove,
            lastApproveUser: firstAndLastApproved.lastApprove,
            processingTimeStr: EventEditItem.getProcessingTimeStr(firstAndLastApproved.lastApprove, state.event.publishUser, state.event.createUser)
        });
    };
    // #endregion Handlers

    // #region Messages
    handleMessageAdded = (newMessage: IEventEditItemMessage) => {
        if (!newMessage) return;
        const state = this.state;
        this.setState({
            messages: EventEditItemMessage.sortEventEditItemMessages(state.messages.concat([newMessage]))
        });
    };

    handleMessageRead = (id: string) => {
        if (!id) return;
        const state = this.state;
        const messages = state.messages.slice(0);
        const message = messages.find(i => i.id === id && !i.isRead);
        message.isRead = true;
        this.setState({
            messages
        });
    };
    // #endregion Messages

    getSaveDataFromState = (props: IEventEditDialogProp, state: IEventEditDialogState, publish: boolean = false): SaveDataObj => {
        const result = new SaveDataObj();
        const event = state.event;
        result.append("id", state.id);
        result.append("rowId", state.rowId);
        result.append("activeCompanyId", props.companyId);
        result.append("companyId", event.companyId);
        result.append("unitId", state.unitId);
        result.append("urgencyClassId", state.urgencyClassId);
        result.append("createCompanyId", event.createCompanyId);
        result.append("createCompanyUnitId", state.createCompanyUnitId);
        result.append("date", Base.getDateTime(state.dateStr, state.timeStr).getTime());
        result.append("name", state.name);
        result.append("observer", state.observer);
        result.append("observerAction", state.observerAction);
        result.append("description", state.description);
        result.append("immediateAction", state.immediateAction);
        result.append("preventiveAction", state.preventiveAction);
        result.append("rootCause", state.rootCause);
        result.append("identificationDetails", state.identificationDetails);
        result.append("directCosts", state.directCostsStr.toDecimal());
        result.append("indirectCosts", state.indirectCostsStr.toDecimal());
        result.append("amount", state.amountStr.toDecimal());
        result.append("publish", publish);
        return result;
    };
    
    checkErrors = (): Promise<boolean> => {
        const state = this.state;
        return new Promise<boolean>((resolve) => {
            if (!state.dateStr) {
                AppUtils.showErrorMessage(Translations.DateMustBeDefined);
                return resolve(false);
            }
            if (!state.name) {
                AppUtils.showErrorMessage(Translations.TitleMustBeDefined);
                return resolve(false);
            }
            if (!state.description) {
                AppUtils.showErrorMessage(Translations.DescriptionMustBeDefined);
                return resolve(false);
            }
            if (state.eventSetting.observerActionIsRequired() && !state.observerAction) {
                AppUtils.showErrorMessage(Translations.ObserverActionMustBeDefined);
                return resolve(false);
            }
            return resolve(true);
        });
    };

    saveToDb = async (publish: boolean): Promise<SaveSuccess> => {
        const props = this.props;
        const state = this.state;
        if (!await AppUtils.validate(this.checkErrors)) return null;
        const saveData = this.getSaveDataFromState(props, state, publish);
        //Call server
        const result = await AppUtils.callService(() => eventService.saveEventEdit(saveData.obj));
        if (!result) return null;
        //Update state and hash
        const stateChange = { id: result.id, rowId: result.rowId };
        this.orgStateHash = this.getSaveDataFromState(props, { ...state, ...stateChange }, publish).hash;
        this.setState(stateChange);
        return result;
    };

    handlePrint = async () => {
        const state = this.state;
        if (!state.event) return;
        const fileName = await AppUtils.callService(() => eventService.getEventPrint(this.props.companyId, state.id, this.defaultPrintId));
        if (!fileName) return;
        AppUtils.showSuccessMessage(String.format(Translations.PrintParameterDownloaded, fileName));
    };

    handleSave = async (closeDialog: boolean, publish: boolean): Promise<SaveSuccess> => {
        const props = this.props;
        const result = await this.saveToDb(publish);
        if (!result) return null;
        if (!closeDialog) {
            await this.loadEvent(result.id);
            props.onOk();
        } else {
            props.onClose();
        }
        return result;
    };

    handleRemove = async () => {
        const props = this.props;
        const state = this.state;
        if (!state.canRemoveEvent || !state.event || state.event.isNew()) return;
        if (await AppUtils.showConfirmationDialog(String.format(Translations.DoYouReallyWantToRemoveEventParameter, state.event.name), false, removeConfirmationWord) === ConfirmationDialogResult.Yes) {
            // Call server
            const result = await AppUtils.callService(() => eventService.removeEvent(props.companyId, state.event.createCompanyId, state.id));
            if (!result) return;
            props.onRemoved();
            this.setState({ lockedUser: null }, props.onClose);
        }
    };

    handleCancel = async () => {
        const props = this.props;
        const state = this.state;
        const cancelResult = await AppUtils.cancel(this.getSaveDataFromState(props, state).hash, this.orgStateHash, null);
        if (cancelResult === ConfirmationDialogResult.Cancel) return;
        if (cancelResult === ConfirmationDialogResult.Yes) {
            this.handleSave(true, false);
        } else {
            props.onClose();
        }
    };

    canMoveOut = async (): Promise<boolean> => {
        const props = this.props;
        return await AppUtils.canMoveOut(this.getSaveDataFromState(props, this.state).hash, this.orgStateHash,
            async () => !!await this.saveToDb(false),
            props.onRefreshList,
            (newStateHash) => { this.orgStateHash = newStateHash; }
        );
    };

    handlePrevious = async () => {
        if (!await this.canMoveOut()) return;
        this.props.onPrevious();
    };

    handleNext = async () => {
        if (!await this.canMoveOut()) return;
        this.props.onNext();
    };

    render() {
        const props = this.props;
        const state = this.state;
        const event = state.event;
        if (!event) return null;
        const isNew = event.isNew();
        const isPublished = event.isPublished();
        const hasBeenApproved = !!state.handlers.find(i => i.date);
        const activeCompanyIsReceivingCompany = props.companyId === event.companyId;
        const identificationDataIsVisible = state.userIsCreator || state.canEditIdentificationData;
        const locationIsVisible = state.eventSetting?.locationIsInUse() && event.locationName;
        return (
            <Dialog
                id="event-edit-dialog"
                maxWidth="xl"
                maxHeight="100%"
                title={Translations.EditEvent + ": " + event.name + " (" + event.stateStr + (state.isLockedToOtherUser ? ", " + Translations.Locked : "") + ")"}
                overflowY="hidden"
                dialogTabs={
                    <DialogTabs
                        activeTabId={state.activeMenuItem}
                        tabs={[
                            { id: EventEditDialogMenuItem.Event, title: Translations.Event },
                            { id: EventEditDialogMenuItem.Handling, title: Translations.Handling },
                            { id: EventEditDialogMenuItem.Identification, title: Translations.Identification, hidden: !identificationDataIsVisible },
                            { id: EventEditDialogMenuItem.Location, title: Translations.Location, hidden: !locationIsVisible },
                        ]}
                        onChangeTab={this.handleToggleActiveMenuItem}
                    />
                }
                body={
                    <>
                        {state.activeMenuItem === EventEditDialogMenuItem.Event &&
                            <EventEditDialogBasicInformation
                                eventSetting={state.eventSetting}
                                companyId={props.companyId}
                                hasBeenApproved={hasBeenApproved}
                                isSuperAdmin={props.sessionState.isSuperAdmin}
                                canHandleEvent={state.canHandleEvent}
                                canEditIdentificationData={state.canEditIdentificationData}
                                isLockedToOtherUser={state.isLockedToOtherUser}
                                userIsCreator={state.userIsCreator}
                                isClosed={!!state.lastApproveUser}
                                event={state.event}
                                createCompany={state.createCompany}
                                companies={state.companies}
                                units={state.units}
                                urgencyClasses={state.urgencyClasses}
                                dateStr={state.dateStr}
                                timeStr={state.timeStr}
                                unitId={state.unitId}
                                unitCode={state.unitCode}
                                urgencyClassId={state.urgencyClassId}
                                createCompanyUnitCode={state.createCompanyUnitCode}
                                name={state.name}
                                observer={state.observer}
                                observerAction={state.observerAction}
                                description={state.description}
                                attachments={state.attachments}
                                lockedUser={state.lockedUser}
                                lastApproveUser={state.lastApproveUser}
                                firstApproveUser={state.firstApproveUser}
                                onChange={this.handleChange}
                                onSelectUnit={this.handleSelectUnit}
                                onRemoveAttachment={(id) => this.handleAttachmentRemove(0, id)}
                                onDownloadAttachment={this.handleAttachmentDownload}
                                onAddAttachments={(fileList) => this.handleAttachmentsAdd(0, fileList)}
                                onUnlock={this.handleUnlockAndLockToMe}
                            />
                        }
                        {state.activeMenuItem === EventEditDialogMenuItem.Handling &&
                            <EventEditDialogAction
                                eventSetting={state.eventSetting}
                                maxEventMessageAttachmentSize={state.maxEventMessageAttachmentSize}
                                companyId={props.companyId}
                                unitId={state.unitId}
                                unitCode={state.unitCode}
                                userCode={props.sessionState.code}
                                event={state.event}
                                units={state.units}
                                isClosed={!!state.lastApproveUser}
                                userIsCreator={state.userIsCreator}
                                canHandleEvent={state.canHandleEvent}
                                isLockedToOtherUser={state.isLockedToOtherUser}
                                handlers={state.handlers}
                                processingTimeStr={state.processingTimeStr}
                                lastApproveUser={state.lastApproveUser}
                                immediateAction={state.immediateAction}
                                preventiveAction={state.preventiveAction}
                                rootCause={state.rootCause}
                                attachments={state.attachments}
                                messages={state.messages}
                                onChange={this.handleChange}
                                onRemoveAttachment={(id) => this.handleAttachmentRemove(1, id)}
                                onDownloadAttachment={this.handleAttachmentDownload}
                                onAddAttachments={(fileList) => this.handleAttachmentsAdd(1, fileList)}
                                onAddUsers={this.handleAddHandlers}
                                onRemoveUsers={this.handleRemoveHandlers}
                                onApprove={this.handleApprove}
                                onEventMessageSaved={this.handleMessageAdded}
                                onEventMessageRead={this.handleMessageRead}
                                onSelectUnit={this.handleSelectUnit}
                            />
                        }
                        {state.activeMenuItem === EventEditDialogMenuItem.Identification && identificationDataIsVisible &&
                            <Box sx={{ maxHeight: "calc(100vh - 274px)", display: "flex", flexDirection: "column" }}>
                                <EventEditDialogIdentification
                                    screenHeight={state.screenHeight}
                                    companyId={props.companyId}
                                    event={state.event}
                                    eventTypeNodes={state.eventTypeNodes}
                                    eventTypeBNodes={state.eventTypeBNodes}
                                    eventTypeCNodes={state.eventTypeCNodes}
                                    isClosed={!!state.lastApproveUser}
                                    isLockedToOtherUser={state.isLockedToOtherUser}
                                    canEditIdentificationData={state.canEditIdentificationData}
                                    eventTypeIds={state.eventTypeIds}
                                    eventTypeBIds={state.eventTypeBIds}
                                    eventTypeCIds={state.eventTypeCIds}
                                    identificationDetails={state.identificationDetails}
                                    directCostsStr={state.directCostsStr}
                                    indirectCostsStr={state.indirectCostsStr}
                                    amountStr={state.amountStr}
                                    onChange={this.handleChange}
                                    onBlur={this.handleBlur}
                                    onChangeEventTypeIds={this.handleChangeEventTypeIds}
                                    onChangeEventTypeBIds={this.handleChangeEventTypeBIds}
                                    onChangeEventTypeCIds={this.handleChangeEventTypeCIds}
                                />
                            </Box>
                        }
                        {state.activeMenuItem === EventEditDialogMenuItem.Location &&
                            <>
                                <GoogleMapReact
                                    bootstrapURLKeys={{
                                        key: appConfig.googleApiKey,
                                        language: appConfig.culture
                                    }}
                                    center={{
                                        lat: event.latitude,
                                        lng: event.longitude,
                                    }}
                                    zoom={12}
                                    options={{
                                        streetViewControl: true,
                                        mapTypeControl: true,
                                        mapTypeControlOptions: {
                                            mapTypeIds: ["roadmap", "satellite"]
                                        }
                                    }}
                                >
                                    <MapMarker
                                        classes="red"
                                        tooltip={event.locationName}
                                        {...{ lat: event.latitude, lng: event.longitude }}
                                    />
                                </GoogleMapReact>
                            </>
                        }
                        {state.showSelectUnitDialog &&
                            <SelectUnitDialog
                                nodes={state.units}
                                title={Translations.SelectUnit}
                                firstColumnTitle={Translations.Unit}
                                selectedId={activeCompanyIsReceivingCompany ? state.unitId : state.createCompanyUnitId}
                                onOk={this.handleSelectUnitDialogOk}
                                onCancel={this.handleSelectUnitDialogCancel}
                            />
                        }
                    </>
                }
                actions={
                    <Box display="flex" justifyContent="space-between" width="100%">
                        <DialogItemsNav
                            hasPrevious={props.hasPrevious}
                            hasNext={props.hasNext}
                            onPrevious={this.handlePrevious}
                            onNext={this.handleNext}
                            createUser={!isNew ? state.event.createUser : null}
                            modifyUser={!isNew ? state.event.modifyUser : null}
                            lockedUser={!isNew ? state.event.lockedUser : null}
                            isLockedToOtherUser={!isNew && state.isLockedToOtherUser}
                            onUnlockAndLockToMe={props.sessionState.isSuperAdmin ? this.handleUnlockAndLockToMe : null}
                        />
                        <Box display="flex">
                            {!isNew && (
                                <>
                                    <DangerButton onClick={!isNew && state.canRemoveEvent ? this.handleRemove : null} sx={{ marginRight: "1.5rem" }}>{Translations.Remove}</DangerButton>
                                    <AppButton variant="outlined" onClick={!isNew ? this.handlePrint : null} sx={{ marginRight: ".5rem" }}>{Translations.Print}</AppButton>
                                </>
                            )}
                            <AppButton variant="outlined" onClick={this.handleCancel} sx={{ marginRight: ".5rem" }}>{Translations.Close}</AppButton>
                            {!isPublished && (
                                <AppButton startIcon={<SaveOutlinedIcon />} variant="contained" color="success" onClick={isPublished ? null : () => this.handleSave(false, false)} sx={{ marginRight: ".5rem", backgroundColor: "success.light" }}>{Translations.SaveDraft}</AppButton>
                            )}
                            <ConfirmationButton
                                disabled={!state.isLockedToOtherUser && !state.canSaveEvent}
                                onClick={() => this.handleSave(false, !isPublished)}
                            >
                                {isNew ? Translations.Next : (isPublished ? Translations.Save : Translations.SaveAndSend)}
                            </ConfirmationButton>
                        </Box>
                    </Box>
                }
                onClose={this.handleCancel}/>
        );
    }
}